import isEmpty from 'lodash/isEmpty';

import Empty from '../Empty';
import Pagination from '../Pagination';
import PressItem from './PressItem';

export default function Press({ press, isMobile = false, onPageChange, currentPage }: any) {
    return (
        <>
            {!isEmpty(press?.content) && (
                <div className="aiSearchPressContainer">
                    {press?.content?.map((pressItem: any) => (
                        <PressItem pressItem={pressItem.content} hasImg={true} key={pressItem.id} isMobile={isMobile} />
                    ))}
                    {press?.total > 8 && (
                        <div className="aiSearchProductsPagination">
                            <Pagination current={currentPage} total={press?.total} pageSize={8} onChange={onPageChange} />
                        </div>
                    )}
                </div>
            )}
            {isEmpty(press?.content) && <Empty isMobile={isMobile} />}
        </>
    );
}
